










































































import Vue from "vue";
import { User, UserFile } from "@/store/types";
import uploadFile from "@/plugins/storage";
import { db, functions, storage } from "@/plugins/firebase";
import { mapGetters } from "vuex";
import UserImage from "@/components/UserImage.vue";

interface AddFile {
  file: File | null;
  comment: string;
  progress: number;
}

export default Vue.extend({
  name: "UserFiles",
  components: { UserImage },
  data: () => ({
    addFile: {
      file: null,
      comment: "",
      progress: 0
    } as AddFile,
    loading: false,
    doneUploadingArtworkDone: false
  }),
  methods: {
    async done(event: Event) {
      if (!this.doneUploadingArtworkDone) {
        this.loading = true;
        try {
          const result = await functions.httpsCallable(
            "doneUploadingArtwork"
          )();
          this.loading = false;
          this.doneUploadingArtworkDone = true;
        } catch (e) {
          alert(e.message);
          console.error(e);
          this.loading = false;
        }
      }
    },
    async addFiles(event: Event) {
      const file = this.addFile.file;
      if (!file) {
        return;
      }
      const userFile = await this.$store.dispatch("files/addFile", {
        id: "",
        bucket: "",
        fullPath: "",
        downloadURL: "",
        name: file.name,
        size: file.size,
        type: file.type,
        comment: this.addFile.comment
      });
      const ref = await uploadFile(
        storage.ref(`${this.userRefPath()}/files/${userFile.id}`),
        file,
        (progress: number) => {
          this.addFile.progress = progress;
        }
      );
      await this.$store.dispatch("files/updateFile", {
        id: userFile.id,
        bucket: ref.bucket,
        fullPath: ref.fullPath,
        downloadURL: await ref.getDownloadURL()
      });
      this.addFile.file = null;
      this.addFile.comment = "";
      this.addFile.progress = 0;
    }
  },
  computed: {
    ...mapGetters("users", ["fullName", "userRefPath"]),
    allFiles() {
      return this.$store.state.files.files.filter(
        (f: UserFile) => f.downloadURL
      );
    }
  }
});
